import React from 'react'
import {Icon} from '@chakra-ui/react'

const CompletedIcon = (props) => {
    return (
        <Icon viewBox="0 0 48 48" {...props}>
            <path
                d="M15.9528 22.3775L23.6646 28.4322L36.8536 12.8205L38.3203 14.0595L23.9358 31.0862L14.7672 23.8876L15.9528 22.3775Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48ZM24 46.08C36.1945 46.08 46.08 36.1945 46.08 24C46.08 11.8056 36.1945 1.92 24 1.92C11.8056 1.92 1.92 11.8056 1.92 24C1.92 36.1945 11.8056 46.08 24 46.08Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CompletedIcon
